<template>
  <div>
    <div class="main" style="margin-top: 5px;">
      <el-col :span="24" style="height: 930px;">
        <div class="container container_col" id="app">

          <div class="page-right" style="width: 1200px;border: 1px solid #e4e4e4;margin-top: 20px;margin-right: 20px">
            <div class="pagelujing">
              <div class="name">&nbsp;&nbsp;&nbsp;&nbsp;联系我们</div>
            </div>
            <div class="news-txt ny mg-t-b">
              <div class="news-con" style="height:800px;">

                <div style="height:900px;text-align: center;margin-top:0px;">


                  <div style="width:250px;height:250px;;margin-left:300px;float: left;margin-top: 0px;">
                    <img src="../../../assets/aboutUS/xinyang_app.jpg" style="width: 100%;height: 100%;" />
                  </div>
                  <div style="width:250px;height:230px;float: left;margin-top: 0px;">
                    <img src="../../../assets/aboutUS/xinyang_gongzhonghao.jpg" style="width: 250px;height: 230px;" />
                    <div style="width:100%;text-align: center;margin-top: -5px;font-size: 18px;color: #00726e;font-weight: 800;">产权交易公众号</div>
                  </div>

                  <div
                    style="float:left;text-align: left;height:80px;width:700px;margin-left: 100px;font-size: 20px;margin-top:20px;">
                    <span v-if="unitInfo.phone!=''&&unitInfo.phone!=null">
                      <strong>联系电话</strong>：{{unitInfo.phone }}
                   </span>
                    <br /> <br />
                    <span v-if="unitInfo.address!=''&&unitInfo.address!=null">
                    <strong>地址</strong>：{{ unitInfo.address }}
                  </span>
                  </div>

                  <div id="container" style="width:80%;height:500px;margin-left: 10%;float:left;margin-top:-10px;">

                  </div>

                </div>



              </div>
            </div>

          </div>
        </div>
      </el-col>


    </div>

  </div>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";

export default {
  data() {
    return {
      unitCode: localStorage.getItem("unitCode"), //"410825000000",
      contact_phone: localStorage.getItem("contact_phone"),
      contact_address: localStorage.getItem("contact_address"),
      leaveWords: [],
      unitInfo:{},
      pageNum: 1, // 默认显示第几页
      totalCount: 0, // 总条数，根据接口获取数据长度(注意：这里不能为空)
      pageSizes: [5, 10, 15, 20], // 个数选择器（可修改）
      pageSize: 10, // 默认每页显示的条数（可修改）
      type: "",
      activeSelect: 1,
      typeName: "",


    }
  },
  mounted() {
    this.getUnitInfo();
  

  },
  methods: {
    async getUnitInfo(){
      const action = "/web/unitCode/getByUnitCode/" +localStorage.getItem("unitCode");
      const {
        data: res
      } = await this.$http.get(action);
      this.unitInfo = res.data;
      this.initAMap(this.unitInfo.location);
    },

    initAMap(location) {
      AMapLoader.load({
        key: "c3aaff0b1cc2a6a64b90786128fde5b5", // 申请好的Web端开发者Key，首次调用 load 时必填
        //  version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.DistrictLayer', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.DistrictSearch'],
        //   // 高德 sdk 版本，默认为 1.4.4
      })
        .then((AMap) => {
          this.map = new AMap.Map("container", {
            zoom: 13, // 初始化地图级别
            center: [location.split(",")[0],location.split(",")[1]], // 初始化地图中心点位置
          });
          const marker = new AMap.Marker({
                    position:[location.split(",")[0],location.split(",")[1]], 
            });
            this.map.add(marker);
        })
        .catch((e) => {
          console.log(e);
        });

    },
    async getWords() {

      // this.type=='1'?this.typeName="通知公告":this.typeName="处置公告";
      if (this.type == 1) {
        this.typeName = "互动问答";
      } else if (this.type == 2) {
        this.typeName = "常见问题";
      }

      const action = "/web/leave/list?unitCode=" + this.unitCode + "&pageNum=" + this.pageNum + "&pageSize=" + this
        .pageSize;
      const {
        data: res
      } = await this.$http.get(action);
      this.leaveWords = res.data.list;
      this.totalCount = res.data.total;
      console.log(res)
    },
    saveLeaveWord() {
      this.$http.post("/web/leave/add", this.leaveWord).then((res) => {
        alert("留言发布成功");
        this.getWords();
      });
    },

    selectedActive(type) {
      this.activeSelect = type;
    },
    jump(id) {
      window.location.href = "noticeDetail.html?type=" + this.type + "&id=" + id;
    },
    handleSizeChange(val) { // 每页显示的条数，选择每页条数的时候执行
      console.log("handleSizeChange")
      this.pageSize = val // 改变每页显示的条数
      this.getWords() // 点击每页显示的条数时，显示第一页
      this.pageNum = 1 // 注意：在改变每页显示的条数时，要将页码显示到第一页
    },
    // 显示第几页
    handleCurrentChange(val) {
      this.pageNum = val; // 改变默认的页数
      this.getWords() // 切换页码时，要获取每页显示的条数
    },
    handleClose(done) {
      done();
    },


  }



};
</script>

<style scoped="">
@import url("../../../assets/css/index.css");
@import url("../../../assets/css/base.css");
@import url("../../../assets/css/main.css");
@import url("../../../assets/css/news.css");

.per {
  width: 98%;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #9796a72e;
  cursor: pointer;
}

.typeNav {
  width: 200px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  cursor: pointer;
  border-bottom: 1px solid #f6f6f6;
}

.navTitle {
  border-bottom: 1px solid #f6f6f6;
  text-align: center;
  height: 50px;
  line-height: 50px;
  width: 200px;
  background-color: #f6f6f6;
  font-size: 20px;

}

.activeSelectType {
  background-color: #4cb050;
  color: white;
}

.hone-container {
  height: 100%;
}

a-layout-content {
  height: 100%;
}

.ant-layout-header {
  /* 2850A0 */
  padding: 0px;
  background-color: #3c8dbc !important;
}

.main {
  width: 1220px;
  margin: 0 auto;
  height: auto;
  overflow: hidden;
  background-color: white;
  margin-top: 5px;
}
</style>
